<template>
  <ModalDefault modal_id="alertLimitChatModal"
                header="y"
                class_header="border-bottom-0"
                class_footer="border-top-0"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_406')"
                footer=""
                icon="bx bx-error">
    <div class="px-3 py-2 pb-4" slot="body">
      <div class="row ">
        <div class="col-12 pt-1 pb-0 text-center title-color">
          <div style="display: flex;
                      justify-content: center;">
            <div class="icon-circle bg-danger-soft">
              <i class="bx bxs-error text-danger"
                 style="font-size: 30px;"></i>
            </div>
          </div>
          <h5 class="pt-3">{{ getTranslations('expression_1098') }}!</h5>
        </div>
        <div class="pt-2 pb-4 px-3 col-12 text-center">
          {{ getTranslations('expression_1099') }}
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";

export default {
  name: "ModalAlertLimitsChat",
  components: {
    ModalDefault
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped>

.icon-circle {
  height: 4rem;
  width: 4rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-danger-soft {
  background-color: #fbdada !important;
}
</style>
